import { useState, useEffect } from 'react';

import { useAppDispatch } from 'data/store';
import { FeatureFlag } from 'data/models/featureFlag';
import { checkFeatureFlag } from 'data/actions/featureFlag';

export const useFeatureFlag = (flag?: FeatureFlag, iaCode?: string): boolean => {
  const dispatch = useAppDispatch();
  const [featureFlagEnabled, setFeatureFlagEnabled] = useState(false);

  useEffect(() => {
    const getFeatureFlag = async (flag: FeatureFlag) => {
      const featureFlagResponse = await dispatch(checkFeatureFlag(flag, iaCode));
      setFeatureFlagEnabled(featureFlagResponse.featureEnabled);
    };
    if (flag === undefined) {
      setFeatureFlagEnabled(true);
    } else {
      getFeatureFlag(flag);
    }
  }, [flag, iaCode]);

  return featureFlagEnabled;
};
